export default {
  customers: [],
  customerInfos: null
}
